import script from "./new-support-case-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-support-case-modal.vue?vue&type=script&setup=true&lang=ts"

import "./new-support-case-modal.vue?vue&type=style&index=0&id=15bc9094&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15bc9094"]])

export default __exports__